import { useFunctionalityIndicatorsCommand } from "./hooks/useFunctionalityIndicatorsCommand.js";
import Textfield from "../../common/components/Textfiled";
import Button from "../../common/components/Button";

function RegisterDailyIndicators() {
  const {
    indicators,
    handleChange,
    createIndicator,
    errors: { errors },
  } = useFunctionalityIndicatorsCommand();

  const handleSubmit = (event) => {
    event.preventDefault();
    createIndicator({ ...indicators, type: "diario" });
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">Registrar indicadores diarios</h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Registro de indicadores diarios. Estos valores se registran por
              cada día de operación.
            </p>
            <form onSubmit={handleSubmit}>
              <Textfield
                label="Fecha"
                type="date"
                name="date"
                value={indicators.date}
                onChange={handleChange}
                error={errors.date}
              />

              <Textfield
                label="Excesos de turnos diarios"
                placeholder="Excesos de turnos diarios"
                type="number"
                name="dailyWorkShiftExcesses"
                value={indicators.dailyWorkShiftExcesses}
                onChange={handleChange}
                error={errors.dailyWorkShiftExcesses}
              />

              <Textfield
                label="Viajes de trabajo con exceso de velocidad diarios"
                placeholder="Viajes de trabajo con exceso de velocidad diarios"
                type="number"
                name="dailySpeedingWorkTrips"
                value={indicators.dailySpeedingWorkTrips}
                onChange={handleChange}
                error={errors.dailySpeedingWorkTrips}
              />

              <Button type="submit">Registrar</Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterDailyIndicators;
